<template>
  <Button
    v-if="
      hasRole('profiles', 'ROLE_ADMINISTRATOR') ||
      hasRole('custom', 'WEBCALL_PERMISSION') ||
      hasRole('custom', 'THIRDPARTY_WEBCALL_PERMISSION')
    "
    :to="{ name: 'WebCall' }"
    class="webcall-button"
    block
    large
  >
    <img src="./icn_driver-white.svg" alt="">
    <span v-if="hasMainMenuOpen || isMobileDevice">{{ $t(`${namespace}.buttonLabel`) }}</span>
    <v-icon v-if="hasMainMenuOpen || isMobileDevice" color="white" right small>keyboard_arrow_right</v-icon>
  </Button>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import mediaQueries from 'mixins/mediaQueries'

export default {
  name: 'WebcallButton',
  mixins: [mediaQueries],
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen,
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isMobileDevice () {
      return this.isMobile || this.isTablet
    }
  },
  data () {
    return {
      namespace: 'Components.WebcallButton'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn.webcall-button {
  border-radius: 0;
  bottom: 0;
  height: 54px;
  left: 0;
  padding: 0;
  position: absolute;
  right: 0;
  z-index: 10;

  img {
    margin-right: 8px;
    width: 26px;
  }

  span {
    color: var(--white);
    font-size: var(--base-font-size);
  }
}
</style>
